const valuedInterfaceFilters = [
  {
    columnGroupLabel: "category",
    columnsGroup: ["product_type", "google_product_category"],
  },
];

const valuedInterfaceFiltersColumns = valuedInterfaceFilters.flatMap(
  ({ columnsGroup }) => columnsGroup,
);

const filterOutNonAvailable = (availableFilters: string[]) =>
  valuedInterfaceFilters
    .filter(({ columnsGroup }) =>
      columnsGroup.reduce(
        (acc, key) => acc || availableFilters.includes(key),
        false,
      ),
    )
    .map(({ columnsGroup, columnGroupLabel }) => {
      return {
        columnsGroup: [
          "",
          ...columnsGroup.filter((item) => availableFilters.includes(item)),
        ],
        columnGroupLabel,
      };
    });

export const availableInterfaceFilters = (
  availableCampaignFilters: string[],
) => {
  if (!availableCampaignFilters)
    return { booleanInterfaceControls: [], valuedInterfaceControls: [] };
  const booleanInterfaceControls = availableCampaignFilters.filter(
    (filter) => !valuedInterfaceFiltersColumns.includes(filter),
  );
  const valuedInterfaceControls = filterOutNonAvailable(
    availableCampaignFilters,
  );
  return { booleanInterfaceControls, valuedInterfaceControls };
};
